<template>
    <q-page class="q-pa-md">
        <q-dialog v-model="dialogVisualizador" persistent>
            <q-card style="width: 1200px; max-width: 80vw;" class="shadow-0">
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Vista previa PDF</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section>
                    <div class="text-center">
                        <q-btn icon="download" flat label="Descargar PDF" color="primary" @click="descargarPDF" />
                    </div>
                    <VisualizadorPDF></VisualizadorPDF>
                </q-card-section>
            </q-card>
        </q-dialog>

        <q-dialog v-model="dialogVisualizadorOP" persistent>
            <q-card style="width: 1200px; max-width: 80vw;" class="shadow-0">
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Vista previa PDF</div>
                    <q-space />
                    <q-btn icon="download" flat label="Descargar PDF" color="primary" @click="descargarPDFOP" />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section>
                    <VisualizadorPDF></VisualizadorPDF>
                </q-card-section>
            </q-card>
        </q-dialog>

        <q-dialog class="rounded-borders" v-model="dialogDetalles" persistent>
            <q-card style="width: 1100px; max-width: 80vw;" v-if="selectCotizacion != null">
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Detalles de la Cotización</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section>
                    <q-stepper v-model="step" ref="stepper" header-nav bordered class="shadow-0" color="primary"
                        animated>
                        <q-step :name="1" title="Información General" icon="settings" :done="done1">
                            <q-card class="shadow-0" v-if="selectCotizacion != null">
                                <!-- <q-list bordered>
                                    <q-expansion-item bordered group="somegroup" icon="explore" label="Detalles"
                                        default-opened header-class="text-primary">
                                        <q-card>
                                            <q-card-section>
                                                <div class="row q-col-gutter-md">
                                                    <div class="col-12 col-md-6 ">
                                                        <q-icon name="event" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Fecha de
                                                            solicitud:</span>
                                                        <div class="text-body1 q-pl-lg q-ml-lg">
                                                            {{ selectCotizacion.fecha_solicitud }}
                                                        </div>
                                                        <q-separator />
                                                    </div>
                                                    <div class="col-12 col-md-6">
                                                        <q-icon name="person" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Cliente:</span>
                                                        <div class="text-body1  q-pl-lg q-ml-lg">
                                                            {{ selectCotizacion.rfc_cliente }} {{
                                                                selectCotizacion.razon_social_cliente }}
                                                        </div>
                                                        <q-separator />
                                                    </div>
                                                </div>
                                            </q-card-section>
                                        </q-card>
                                    </q-expansion-item>
                                    <q-separator />
                                    <q-expansion-item bordered group="somegroup" icon="explore"
                                        label="Detalles del Vehiculo" header-class="text-primary">
                                        <q-card>
                                            <q-card-section>
                                                <div class="row q-col-gutter-md">
                                                    <div class="col-12 col-md-4 ">
                                                        <q-icon name="mdi-car" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Marca:</span>
                                                        <div class="text-body1 q-pl-lg q-ml-lg">
                                                            {{ selectCotizacion.marca }}
                                                        </div>
                                                        <q-separator />
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <q-icon name="mdi-car" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Modelo:</span>
                                                        <div class="text-body1  q-pl-lg q-ml-lg">
                                                            {{ selectCotizacion.modelo }}

                                                        </div>
                                                        <q-separator />
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <q-icon name="mdi-car" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Versión:</span>
                                                        <div class="text-body1   q-pl-lg q-ml-lg">{{
                                                            selectCotizacion.version }}</div>
                                                        <q-separator />
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <q-icon name="mdi-car" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Tipo Vehiculo:</span>
                                                        <div class="text-body1   q-pl-lg q-ml-lg">{{
                                                            selectCotizacion.tipovehiculo }}
                                                        </div>
                                                        <q-separator />
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <q-icon name="mdi-car" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Año:</span>
                                                        <div class="text-body1   q-pl-lg q-ml-lg">{{
                                                            selectCotizacion.anio }}
                                                        </div>
                                                        <q-separator />
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <q-icon name="mdi-car" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Color:</span>
                                                        <div class="text-body1   q-pl-lg q-ml-lg">{{
                                                            selectCotizacion.color }}
                                                        </div>
                                                        <q-separator />
                                                    </div>
                                                </div>
                                            </q-card-section>
                                        </q-card>
                                    </q-expansion-item>
                                    <q-separator />
                                    <q-expansion-item bordered group="somegroup" icon="explore"
                                        label="Detalles del Proveedor" header-class="text-primary">
                                        <q-card>
                                            <q-card-section>
                                                <div class="row q-col-gutter-md">
                                                    <div class="col-12 col-md-4 ">
                                                        <q-icon name="mdi-account" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">RFC:</span>
                                                        <div class="text-body1 q-pl-lg q-ml-lg">
                                                            {{ selectCotizacion.rfc }}
                                                        </div>
                                                        <q-separator />
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <q-icon name="mdi-account" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Razón Social:</span>
                                                        <div class="text-body1  q-pl-lg q-ml-lg">
                                                            {{ selectCotizacion.razon_social }}
                                                        </div>
                                                        <q-separator />
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <q-icon name="mdi-account" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Domicilio:</span>
                                                        <div class="text-body1   q-pl-lg q-ml-lg">{{
                                                            selectCotizacion.domicilio_fiscal }}</div>
                                                        <q-separator />
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <q-icon name="mdi-account" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Representante:</span>
                                                        <div class="text-body1   q-pl-lg q-ml-lg">{{
                                                            selectCotizacion.representante }}
                                                        </div>
                                                        <q-separator />
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <q-icon name="mdi-phone" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Teléfono:</span>
                                                        <div class="text-body1   q-pl-lg q-ml-lg">{{
                                                            selectCotizacion.telefono }}
                                                        </div>
                                                        <q-separator />
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <q-icon name="mdi-at" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Correo:</span>
                                                        <div class="text-body1   q-pl-lg q-ml-lg">{{
                                                            selectCotizacion.correo }}
                                                        </div>
                                                        <q-separator />
                                                    </div>
                                                </div>
                                            </q-card-section>
                                        </q-card>
                                    </q-expansion-item>
                                    <q-separator />
                                    <q-expansion-item bordered group="somegroup" icon="explore"
                                        label="Detalles de la cotización" header-class="text-primary">
                                        <q-card>
                                            <q-card-section class="row items-center q-pb-none">
                                                <div class="text-h6">Detalles de la Cotización</div>
                                                <q-space></q-space>
                                                <q-btn flat round icon="mdi-file-document" color="primary"
                                                    @click="verCotizacion()"></q-btn>
                                            </q-card-section>
                                            <q-card-section>
                                                <div class="row q-col-gutter-md">
                                                    <div class="col-12 col-md-4 ">
                                                        <q-icon name="mdi-currency-usd" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Precio:</span>
                                                        <div class="text-body1 q-pl-lg q-ml-lg">
                                                            {{ selectCotizacion.precio }}
                                                        </div>
                                                        <q-separator />
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <q-icon name="mdi-currency-usd" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Anticipo:</span>
                                                        <div class="text-body1  q-pl-lg q-ml-lg">
                                                            {{ selectCotizacion.anticipo }}
                                                        </div>
                                                        <q-separator />
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <q-icon name="mdi-currency-usd" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Seguro:</span>
                                                        <div class="text-body1   q-pl-lg q-ml-lg">{{
                                                            selectCotizacion.seguro }}</div>
                                                        <q-separator />
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <q-icon name="mdi-currency-usd" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Enplacamiento:</span>
                                                        <div class="text-body1   q-pl-lg q-ml-lg">{{
                                                            selectCotizacion.placas }}
                                                        </div>
                                                        <q-separator />
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <q-icon name="mdi-calendar" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Plazos:</span>
                                                        <div class="text-body1   q-pl-lg q-ml-lg">{{
                                                            selectCotizacion.plazo }}
                                                        </div>
                                                        <q-separator />
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <q-icon name="mdi-currency-usd" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Valor Residual:</span>
                                                        <div class="text-body1   q-pl-lg q-ml-lg">{{
                                                            selectCotizacion.valorres }}
                                                        </div>
                                                        <q-separator />
                                                    </div>
                                                </div>
                                            </q-card-section>
                                        </q-card>
                                    </q-expansion-item>
                                    <q-separator />
                                </q-list> -->
                                <q-list bordered>
                                    <q-expansion-item bordered group="somegroup" icon="explore" label="Detalles"
                                        default-opened header-class="text-primary">
                                        <q-card>
                                            <q-card-section>
                                                <div class="row q-col-gutter-md">
                                                    <div class="col-12 col-md-6 ">
                                                        <q-field color="teal" filled label="Fecha de
                                                            solicitud" stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="event" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{
                                                                        selectCotizacion.fecha_solicitud }}
                                                                </div>
                                                            </template>
                                                        </q-field>

                                                        <!-- <q-icon name="event" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Fecha de
                                                            solicitud:</span>
                                                        <div class="text-body1 q-pl-lg q-ml-lg">
                                                            {{ selectCotizacion.fecha_solicitud }}
                                                        </div>
                                                        <q-separator /> -->
                                                    </div>
                                                    <div class="col-12 col-md-6">
                                                        <q-field color="teal" filled label="Cliente" stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="person" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{ selectCotizacion.rfc_cliente + " " +
                                                                        selectCotizacion.razon_social_cliente }}
                                                                </div>
                                                            </template>
                                                        </q-field>

                                                        <!-- <q-icon name="person" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Cliente:</span>
                                                        <div class="text-body1  q-pl-lg q-ml-lg">
                                                            {{ selectCotizacion.rfc_cliente + " " +
                                                                selectCotizacion.razon_social_cliente }}
                                                        </div>
                                                        <q-separator /> -->
                                                    </div>
                                                </div>
                                            </q-card-section>
                                        </q-card>
                                    </q-expansion-item>
                                    <q-separator />
                                    <q-expansion-item bordered group="somegroup" icon="explore"
                                        label="Detalles del Vehiculo" header-class="text-primary">
                                        <q-card>
                                            <q-card-section>
                                                <div class="row q-col-gutter-md">
                                                    <div class="col-12 col-md-4 ">
                                                        <!-- <q-icon name="mdi-car" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Marca:</span>
                                                        <div class="text-body1 q-pl-lg q-ml-lg">
                                                            {{ selectCotizacion.marca }}
                                                        </div>
                                                        <q-separator /> -->
                                                        <q-field color="teal" filled label="Marca" stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="mdi-car" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{
                                                                        selectCotizacion.marca }}
                                                                </div>
                                                            </template>
                                                        </q-field>
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <!-- <q-icon name="mdi-car" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Modelo:</span>
                                                        <div class="text-body1  q-pl-lg q-ml-lg">
                                                            {{ selectCotizacion.modelo }}

                                                        </div>
                                                        <q-separator /> -->
                                                        <q-field color="teal" filled label="Modelo" stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="mdi-car" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{
                                                                        selectCotizacion.modelo }}
                                                                </div>
                                                            </template>
                                                        </q-field>
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <!-- <q-icon name="mdi-car" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Versión:</span>
                                                        <div class="text-body1   q-pl-lg q-ml-lg">{{
                                                            selectCotizacion.version }}</div>
                                                        <q-separator /> -->
                                                        <q-field color="teal" filled label="Versión" stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="mdi-car" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{
                                                                        selectCotizacion.version }}
                                                                </div>
                                                            </template>
                                                        </q-field>
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <!-- <q-icon name="mdi-car" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Tipo Vehiculo:</span>
                                                        <div class="text-body1   q-pl-lg q-ml-lg">{{
                                                            selectCotizacion.tipovehiculo }}
                                                        </div>
                                                        <q-separator /> -->
                                                        <q-field color="teal" filled label="Tipo de Vehiculo"
                                                            stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="mdi-car" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{
                                                                        selectCotizacion.tipovehiculo }}
                                                                </div>
                                                            </template>
                                                        </q-field>
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <!-- <q-icon name="mdi-car" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Año:</span>
                                                        <div class="text-body1   q-pl-lg q-ml-lg">{{
                                                            selectCotizacion.anio }}
                                                        </div>
                                                        <q-separator /> -->
                                                        <q-field color="teal" filled label="Año" stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="mdi-car" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{
                                                                        selectCotizacion.anio }}
                                                                </div>
                                                            </template>
                                                        </q-field>
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <!-- <q-icon name="mdi-car" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Color:</span>
                                                        <div class="text-body1   q-pl-lg q-ml-lg">{{
                                                            selectCotizacion.color }}
                                                        </div>
                                                        <q-separator /> -->
                                                        <q-field color="teal" filled label="Color" stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="mdi-car" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{
                                                                        selectCotizacion.color }}
                                                                </div>
                                                            </template>
                                                        </q-field>
                                                    </div>
                                                </div>
                                            </q-card-section>
                                        </q-card>
                                    </q-expansion-item>
                                    <q-separator />
                                    <q-expansion-item bordered group="somegroup" icon="explore"
                                        label="Detalles del Proveedor" header-class="text-primary">
                                        <q-card>
                                            <q-card-section>
                                                <div class="row q-col-gutter-md">
                                                    <div class="col-12 col-md-4 ">
                                                        <q-field color="teal" filled label="RFC" stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="mdi-account" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{
                                                                        selectCotizacion.rfc }}
                                                                </div>
                                                            </template>
                                                        </q-field>
                                                        <!-- <q-icon name="mdi-account" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">RFC:</span>
                                                        <div class="text-body1 q-pl-lg q-ml-lg">
                                                            {{ selectCotizacion.rfc }}
                                                        </div>
                                                        <q-separator /> -->
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <q-field color="teal" filled
                                                            label="Razón Social o Nombre de la Persona" stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="mdi-account" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{
                                                                        selectCotizacion.razon_social }}
                                                                </div>
                                                            </template>
                                                        </q-field>
                                                        <!-- <q-icon name="mdi-account" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Razón Social:</span>
                                                        <div class="text-body1  q-pl-lg q-ml-lg">
                                                            {{ selectCotizacion.razon_social }}
                                                        </div>
                                                        <q-separator /> -->
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <!-- <q-icon name="mdi-account" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Domicilio:</span>
                                                        <div class="text-body1   q-pl-lg q-ml-lg">{{
                                                            selectCotizacion.domicilio_fiscal }}</div>
                                                        <q-separator /> -->
                                                        <q-field color="teal" filled label="Domicilio" stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="mdi-account" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{
                                                                        selectCotizacion.domicilio_fiscal }}
                                                                </div>
                                                            </template>
                                                        </q-field>
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <!-- <q-icon name="mdi-account" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Representante:</span>
                                                        <div class="text-body1   q-pl-lg q-ml-lg">{{
                                                            selectCotizacion.representante }}
                                                        </div>
                                                        <q-separator /> -->
                                                        <q-field color="teal" filled label="Representante" stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="mdi-account" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{
                                                                        selectCotizacion.representante }}
                                                                </div>
                                                            </template>
                                                        </q-field>
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <q-field color="teal" filled label="Teléfono" stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="mdi-phone" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{
                                                                        selectCotizacion.telefono }}
                                                                </div>
                                                            </template>
                                                        </q-field>
                                                        <!-- <q-icon name="mdi-phone" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Teléfono:</span>
                                                        <div class="text-body1   q-pl-lg q-ml-lg">{{
                                                            selectCotizacion.telefono }}
                                                        </div>
                                                        <q-separator /> -->
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <q-field color="teal" filled label="Correo" stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="mdi-at" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{
                                                                        selectCotizacion.correo }}
                                                                </div>
                                                            </template>
                                                        </q-field>
                                                        <!-- <q-icon name="mdi-at" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Correo:</span>
                                                        <div class="text-body1   q-pl-lg q-ml-lg">{{
                                                            selectCotizacion.correo }}
                                                        </div>
                                                        <q-separator /> -->
                                                    </div>
                                                </div>
                                            </q-card-section>
                                        </q-card>
                                    </q-expansion-item>
                                    <q-separator />
                                    <q-expansion-item bordered group="somegroup" icon="explore"
                                        label="Detalles de la cotización" header-class="text-primary">
                                        <q-card>
                                            <q-card-section class="row items-center q-pb-none">
                                                <div class="text-h6">Detalles de la Cotización</div>
                                                <q-space></q-space>
                                                <q-btn flat round icon="mdi-file-document" color="primary"
                                                    @click="verCotizacion()"></q-btn>
                                            </q-card-section>
                                            <q-card-section>
                                                <div class="row q-col-gutter-md">
                                                    <div class="col-12 col-md-4 ">
                                                        <!-- <q-icon name="mdi-currency-usd" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Precio:</span>
                                                        <div class="text-body1 q-pl-lg q-ml-lg">
                                                            {{ selectCotizacion.precio }}
                                                        </div>
                                                        <q-separator /> -->
                                                        <q-field color="teal" filled label="Precio" stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="mdi-currency-usd" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{
                                                                        formatoMonedaMexicana(selectCotizacion.precio) }}
                                                                </div>
                                                            </template>
                                                        </q-field>
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <!-- <q-icon name="mdi-currency-usd" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Anticipo:</span>
                                                        <div class="text-body1  q-pl-lg q-ml-lg">
                                                            {{ selectCotizacion.anticipo }}
                                                        </div>
                                                        <q-separator /> -->

                                                        <q-field color="teal" filled label="Anticipo" stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="mdi-currency-usd" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{
                                                                        formatoMonedaMexicana(selectCotizacion.anticipo) }}
                                                                </div>
                                                            </template>
                                                        </q-field>
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <!-- <q-icon name="mdi-currency-usd" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Seguro:</span>
                                                        <div class="text-body1   q-pl-lg q-ml-lg">{{
                                                            selectCotizacion.seguro }}</div>
                                                        <q-separator /> -->
                                                        <q-field color="teal" filled label="Seguro" stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="mdi-currency-usd" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{
                                                                        formatoMonedaMexicana(selectCotizacion.seguro) }}
                                                                </div>
                                                            </template>
                                                        </q-field>
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <!-- <q-icon name="mdi-currency-usd" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Enplacamiento:</span>
                                                        <div class="text-body1   q-pl-lg q-ml-lg">{{
                                                            selectCotizacion.placas }}
                                                        </div>
                                                        <q-separator /> -->
                                                        <q-field color="teal" filled label="Placas" stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="mdi-currency-usd" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{
                                                                        formatoMonedaMexicana(selectCotizacion.placas) }}
                                                                </div>
                                                            </template>
                                                        </q-field>
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <!-- <q-icon name="mdi-calendar" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Plazos:</span>
                                                        <div class="text-body1   q-pl-lg q-ml-lg">{{
                                                            selectCotizacion.plazo }}
                                                        </div>
                                                        <q-separator /> -->
                                                        <q-field color="teal" filled label="Plazos" stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="mdi-calendar" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{
                                                                        selectCotizacion.plazo }}
                                                                </div>
                                                            </template>
                                                        </q-field>
                                                    </div>
                                                    <div class="col-12 col-md-4">
                                                        <!-- <q-icon name="mdi-currency-usd" color="primary" size="sm"
                                                            class="q-mr-sm" />
                                                        <span class="text-subtitle2 text-grey-7">Valor Residual:</span>
                                                        <div class="text-body1   q-pl-lg q-ml-lg">{{
                                                            selectCotizacion.valorres }}
                                                        </div>
                                                        <q-separator /> -->
                                                        <q-field color="teal" filled label="Valor Residual" stack-label>
                                                            <template v-slot:prepend>
                                                                <q-icon name="mdi-currency-usd" color="primary" />
                                                            </template>
                                                            <template v-slot:control>
                                                                <div class="self-center full-width no-outline"
                                                                    tabindex="0">{{
                                                                        formatoMonedaMexicana(selectCotizacion.valorres) }}
                                                                </div>
                                                            </template>
                                                        </q-field>
                                                    </div>
                                                </div>
                                            </q-card-section>
                                        </q-card>
                                    </q-expansion-item>
                                    <q-separator />
                                </q-list>
                            </q-card>
                        </q-step>

                        <q-step :name="2" title="Cuenta Por Pagar" icon="create_new_folder" :done="done2">
                            <q-card class="shadow-0" v-if="selectCotizacion != null">

                                <q-card-section class="row items-center  q-pb-none">
                                    <div class="text-h6">Cuentas Por Pagar</div>
                                    <q-space></q-space>
                                    <q-btn icon="mdi-file-document" flat round color="primary" dense
                                        @click="generaPdfOrdenPago()" />

                                </q-card-section>
                                <q-card-section class="row items-center q-pb-none q-col-gutter-md">
                                    <div class="col-12 col-md-6">
                                        <q-input v-model="fechaCuenta" readonly dense outlined label="Fecha"
                                            class="full-width" />
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <q-input v-model="cuentaCobrar.nombre" readonly dense outlined label="Nombre"
                                            class="full-width" />
                                    </div>
                                    <div class="col-12 col-md-12">
                                        <q-input v-model="cuentaCobrar.concepto" readonly dense outlined
                                            label="Concepto" class="full-width" />
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <q-chip v-if="cuentaCobrar.estado == 'XC'" color="deep-orange"
                                            text-color="white" icon="mdi-clock-alert-outline">
                                            Pendiente de Pagar
                                        </q-chip>
                                        <q-chip v-if="cuentaCobrar.estado == 'V'" color="deep-purple" text-color="white"
                                            icon="mdi-file-clock">
                                            Valiando Pago
                                        </q-chip>
                                        <q-chip v-if="cuentaCobrar.estado == 'P'" color="green" text-color="white"
                                            icon="mdi-check-bold">
                                            Pagado
                                        </q-chip>

                                    </div>
                                    <div class="col-12 col-md-6">
                                        <q-field input-class="text-right" dense outlined stack-label
                                            label="Pago Inicial" class="full-width">
                                            <template v-slot:control>
                                                <div class="self-center full-width no-outline" tabindex="0"> {{
                                                    formatoMonedaMexicana(cuentaCobrar.monto) }}</div>
                                            </template>
                                        </q-field>
                                    </div>
                                    <div class="row doc-note full-width" v-if="cuentaCobrar.estado == 'XC'">
                                        <div class="col-12">
                                            <div class="doc-note__title">Aviso</div>
                                        </div>
                                        <div class="col-12">
                                            <div>Usted tiene una cuenta pendiente por Pagar para poder proceder con el
                                                contrato. Puede ver el pago pendiente en el apartado Cuentas por Pagar.
                                            </div>
                                        </div>
                                    </div>
                                </q-card-section>
                            </q-card>
                        </q-step>

                        <q-step :name="3" title="Factura" icon="create_new_folder" :done="done1">
                            <q-card class="shadow-0" v-if="selectCotizacion != null">
                                <q-card-section class="row items-center q-pb-none">
                                    <div class="text-h6">Factura</div>
                                </q-card-section>
                            </q-card>
                        </q-step>

                        <q-step v-if="selectCotizacion.estatus == 'ContratoVigente'" :name="4" title="Contrato"
                            icon="create_new_folder" :done="done4">
                            <q-card class="shadow-0" v-if="selectCotizacion != null">
                                <q-card-section class="row items-center q-pb-none">
                                    <div class="text-h6">Contrato</div>
                                </q-card-section>
                                <q-separator class="q-my-md" />
                                <q-card-section class="row items-center q-pb-none q-col-gutter-md">
                                    <VisualizadorPDFContrato></VisualizadorPDFContrato>
                                </q-card-section>
                            </q-card>
                        </q-step>

                    </q-stepper>
                </q-card-section>
            </q-card>
        </q-dialog>

        <div class="row q-pt-md q-col-gutter-md">
            <div class="col-12">
                <q-table dense title="Mis Cotizaciones" class="shadow-1" :data="cotizaciones" :loading="loading"
                    :columns="columns" color="primary" row-key="_id" :pagination="initialPagination">
                    <template v-slot:top-right>
                        <q-btn outline color="primary" icon="mdi-refresh" label="Consultar" @click="GetCotizaciones()"
                            no-caps class="q-my-md" />
                    </template>
                    <template v-slot:body="props">
                        <q-tr :props="props" class="hover-fila">
                            <q-td key="rfc_cliente" :props="props" @click="verItem(props.row)">{{ props.row.rfc_cliente
                                }}</q-td>
                            <q-td key="razon_social_cliente" :props="props" @click="verItem(props.row)">{{
                                props.row.razon_social_cliente }}</q-td>
                            <q-td key="vehiculo" :props="props" @click="verItem(props.row)">{{
                                props.row.marca + ' ' + props.row.modelo + ' ' + props.row.version
                                }}</q-td>
                            <q-td key="proveedor" :props="props" @click="verItem(props.row)">{{
                                props.row.rfc + ' - ' + props.row.razon_social
                            }}</q-td>
                            <q-td key="precio" :props="props" @click="verItem(props.row)">{{
                                formatoMonedaMexicana(props.row.precio)
                                }}</q-td>
                            <q-td key="plazo" :props="props" @click="verItem(props.row)">{{
                                props.row.plazo
                                }}</q-td>
                            <q-td key="anticipo" :props="props" @click="verItem(props.row)">{{
                                formatoMonedaMexicana(props.row.anticipo)
                                }}</q-td>

                            <q-td key="fecha_solicitud" :props="props" @click="verItem(props.row)">{{
                                props.row.fecha_solicitud
                            }}</q-td>
                            <q-td key="estatus" :props="props">
                                <q-badge v-if="props.row.estatus == 'Aceptada'" color="green"
                                    label="EsperandoRespuesta" />
                                <q-badge v-if="props.row.estatus == 'EnProceso'" color="purple"
                                    :label="props.row.estatus" />
                                <q-badge v-if="props.row.estatus == 'PendienteDeContrato'" color="blue"
                                    :label="props.row.estatus" />
                                <q-badge v-if="props.row.estatus == 'ContratoVigente'" color="black"
                                    :label="props.row.estatus" />
                            </q-td>
                        </q-tr>
                    </template>
                </q-table>
            </div>
        </div>

    </q-page>
</template>
<script>
import axios from "axios";
import { QSpinnerClock } from 'quasar'
import VisualizadorPDF from "../../PDF/VistasPreviasPDF.vue";
import { generarOrdenPagoPDF } from '../../PDF/OrdenPago.js' // Ajusta esta ruta
import VisualizadorPDFContrato from "../../PDF/VisualizadorContrato.vue";

import moment from 'moment';
export default {
    components: {
        VisualizadorPDF, VisualizadorPDFContrato
    },
    data() {
        return {
            loading: false,
            cotizaciones: [],
            columns: [
                { name: 'rfc_cliente', label: 'RFC', field: 'cliente', align: 'rfc_cliente', sortable: true },
                { name: 'razon_social_cliente', label: 'Razón Social o Nombre de la Persona', field: 'razon_social_cliente', align: 'center', sortable: true },
                { name: 'vehiculo', label: 'Vehiculo', field: 'vehiculo', align: 'center', sortable: true },
                { name: 'proveedor', label: 'Proveedor', field: 'proveedor', align: 'center', sortable: true },
                { name: 'precio', label: 'Precio', field: 'precio', align: 'center', sortable: true },
                { name: 'anticipo', label: 'Anticipo', field: 'anio', align: 'center', sortable: true },
                { name: 'estatus', label: 'Estatus', field: 'estatus', align: 'center', sortable: true },
                { name: 'fecha_solicitud', label: 'Fecha de Solicitud', field: 'fecha_solicitud', align: 'center', sortable: true },
            ],
            initialPagination: {
                sortBy: 'nombre',
                descending: false,
                page: 1,
                rowsPerPage: 10
            },
            dialogDetalles: false,
            selectCotizacion: null,
            step: 1,
            done1: false,
            done2: false,
            done3: false,
            done4: false,
            documentosUsuario: [],
            dialogVisualizador: false,

            cuentaCobrar: {
                nombre: '',
                monto: '',
                concepto: '',
                tipo: 'Adelanto',
                id_documento: '',
                id_cliente: '',
                estado: ''
            },
            fechaCuenta: '',
            dialogConfirmacion: false,
            dialogVisualizadorOP: false
        }
    },
    mounted() {
    },
    computed: {
        userStore() {
            return this.$store.state.auth.usuario;
        },
    },
    created() {
        this.GetCotizaciones();
    },
    methods: {
        async GetCotizaciones() {
            this.loading = true
            try {
                let respuesa = await axios.get('Catalogos/GetCotizacionesAceptadasXusuario/' + this.userStore._id)
                console.log(respuesa.data)
                this.cotizaciones = respuesa.data
                this.loading = false
            } catch (error) {
                this.loading = false
                console.log(error)
            }
        },
        async GetCxCXidCotizacion() {
            try {
                let respuesta = await axios.get('CXC/GetCxCXidDOc/' + this.selectCotizacion._id)
                console.log('cc', respuesta.data)
                if (respuesta.data.edopet == '-1') {
                    this.cuentaCobrar = {
                        nombre: '',
                        monto: '',
                        concepto: '',
                        tipo: 'Adelanto',
                        id_documento: '',
                        id_cliente: '',
                        estado: ''
                    }
                } else {
                    let cuenta = respuesta.data.lista[0]

                    this.cuentaCobrar.concepto = cuenta.concepto
                    this.fechaCuenta = this.formatearFecha(cuenta.fechacreacion)
                    this.cuentaCobrar.nombre = cuenta.nombre
                    this.cuentaCobrar.monto = this.formatoMonedaMexicana(cuenta.monto)
                    this.cuentaCobrar.estado = cuenta.estado
                }
                // this.cuentaCobrar.concepto = respuesta.data.concepto
                // this.fechaCuenta = this.formatearFecha(respuesta.data.fechacreacion)
                // this.cuentaCobrar.nombre = respuesta.data.nombre
                // this.cuentaCobrar.monto = this.formatoMonedaMexicana(respuesta.data.monto)
                // this.cuentaCobrar.estado = respuesta.data.esatdo



            } catch (error) {
                this.loading = false
                console.log(error)
            }
        },

        async verItem(item) {
            this.selectCotizacion = item
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Consultando detalles. Espere...', messageColor: 'white' })
            await this.GetCxCXidCotizacion();
            if (this.selectCotizacion.estatus == 'ContratoVigente') {
                await this.GetContratoXIdCotizacion()
            }
            this.$q.loading.hide()
            this.dialogDetalles = true
        },
        async GetContratoXIdCotizacion() {
            try {
                let respuesa = await axios.get('Contratos/GetContratoXidCotizacion/' + this.selectCotizacion._id)
                this.$store.state.auth.objetoContrato = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },

        async generaPdfOrdenPago() {
            const datos = {
                folio: '4525564',
                proveedor: 'EMPRESA S.A. DE C.V.',
                rfc: 'ABC123456XYZ',
                metodoPago: 'Transferencia',
                conceptos: [
                    { cantidad: 1, descripcion: 'Pago Inicial', precioUnitario: 300000 }
                ],
                banco: 'BBVA',
                cuenta: '0123456789',
                clabe: '012345678901234567',
                beneficiario: 'STAFF CAPTACION S.A. DE C.V.'
            }
            try {

                const logoURL = require('../../../assets/logo_top.png')
                let logoBase64 = await this.cargarImagenComoBase64(logoURL);

                let base64 = ''
                base64 = await generarOrdenPagoPDF(datos, logoBase64);
                this.$store.state.auth.storeBase64Cotizacion = 'data:application/pdf;base64,' + base64.split(',')[1];

                this.dialogVisualizadorOP = true
            } catch (error) {
                console.log(error)
            }
        },

        verCotizacion() {
            this.$store.state.auth.storeBase64Cotizacion = this.selectCotizacion.cotizacion_arrendafit
            this.dialogVisualizador = true
        },

        descargarPDF() {
            const fileName = this.selectCotizacion.nombre_archivo_arrendafit;
            const link = document.createElement("a");
            link.href = this.$store.state.auth.storeBase64Cotizacion;
            link.download = fileName;
            link.click();
        },

        descargarPDFOP() {
            const fileName = 'OrdenPago.pdf';
            const link = document.createElement("a");
            link.href = this.$store.state.auth.storeBase64Cotizacion;
            link.download = fileName;
            link.click();
        },

        formatoMonedaMexicana(valor) {
            return valor.toLocaleString('es-MX', {
                style: 'currency',
                currency: 'MXN',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },
        formatearFecha(isoString) {
            const fecha = new Date(isoString);

            const dia = String(fecha.getUTCDate()).padStart(2, '0');
            const mes = String(fecha.getUTCMonth() + 1).padStart(2, '0');
            const anio = fecha.getUTCFullYear();

            const hora = String(fecha.getUTCHours()).padStart(2, '0');
            const minutos = String(fecha.getUTCMinutes()).padStart(2, '0');
            const segundos = String(fecha.getUTCSeconds()).padStart(2, '0');

            return `${dia}/${mes}/${anio} ${hora}:${minutos}:${segundos}`;
        },
        cargarImagenComoBase64(url) {
            return new Promise((resolve, reject) => {
                const img = new Image()
                img.crossOrigin = 'Anonymous'
                img.onload = function () {
                    const canvas = document.createElement('canvas')
                    canvas.width = this.width
                    canvas.height = this.height
                    const ctx = canvas.getContext('2d')
                    ctx.drawImage(this, 0, 0)
                    const dataURL = canvas.toDataURL('image/png')
                    resolve(dataURL)
                }
                img.onerror = reject
                img.src = url
            })
        },
    }
}
</script>
<style>
.hover-fila:hover td {
    cursor: pointer;
    background: #dcf6ff;
}

.doc-note {
    background-color: #f0f4f8;
    /* Fondo claro */
    border-left: 4px solid #007BFF;
    /* Línea de color azul en el borde izquierdo */
    padding: 16px;
    margin: 16px 0;
    border-radius: 8px;
    color: #333;
    /* Color de texto */
    font-family: Arial, sans-serif;
}

.doc-note__title {
    margin: 0 0 8px 0;
    font-weight: bold;
    color: #007BFF;
    /* Mismo tono del borde para coherencia */
    font-size: 16px;
}

.doc-note p {
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
}
</style>